export class Constants {
    static ExcelMimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    static JsonMimeType = 'application/json';
    static PdfMimeType = 'application/pdf';
    static ZipMimeType = 'application/zip';
}